module.exports = __webpack_public_path__ + "static/media/video.ee28b2b7.svg";